// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2ZQtn","fileBtn":"File_fileBtn__3b7Q5","closeBtn":"File_closeBtn__FSuxz","fileSelected":"File_fileSelected__3wwRA","disabled":"File_disabled__1kLA7"};